import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar.js";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth.js";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Fab from "@mui/material/Fab";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { DatePicker } from "@mui/x-date-pickers";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import moment from "moment";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { themeStyle } from "../../components/Components.js";
import FileOpenIcon from "@mui/icons-material/FileOpen";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const colorList = ["#dfffdbff", "#c0e9ffff", "#fdcacaff"];
const colorList2 = ["#31a354", themeStyle.primaryColor, "#e6550d"];
const colorList3 = ["#addd8e", "#9ecae1", "#a1d99b"];

function LeaveRequestsPrincipal() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [type, setType] = useState("ALL");

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [ogLeaves, setOGLeaves] = useState([]);

  const [leaveId, setLeaveId] = useState("");
  const [userId, setUserId] = useState("");
  const [seeLeaves, setSeeLeaves] = useState("");
  const [leaveDate, setLeaveDate] = useState("");
  const [year, setYear] = useState("2025");
  const [users, setUsers] = useState("TEACHERS");

  const [teacherLeaveRequests, setTeacherLeaveRequests] = useState([]);

  function handleApprovalChange(approval) {
    setType(approval);
    if (approval != "ALL") {
      var tempList = [];
      for (var i = 0; i < ogLeaves.length; i++) {
        if (ogLeaves[i]["status"] == approval) {
          tempList.push(ogLeaves[i]);
        }
      }
      setTeacherLeaveRequests(tempList);
    } else {
      setTeacherLeaveRequests(ogLeaves);
    }
  }

  function handleUsersChange(type) {
    setUsers(type);
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_leave_requests_principal2", body, config)
      .then((res) => {
        setTeacherLeaveRequests(res.data);
        setOGLeaves(res.data);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  function approveLeave(approval) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["leave_request_id"] = leaveId;
    body["leave_date"] = leaveDate;
    body["user_id"] = userId;
    body["approval"] = approval ? "APPROVED" : "REJECTED";
    body["teacher"] = state.auth.user.user_id;

    body["date"] = moment().format("DD-MM-YYYY");
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/approve_leave_requests", body, config)
      .then((res) => {
        getData();
        handleClose();
        createAlert(
          "SUCCESS",
          "Success.",
          approval ? "Leave APPROVED" : "Leave REJECTED"
        );
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getPageContent() {
    return (
      <Fragment>
        <Grid container spacing={1.5}>
          {teacherLeaveRequests.length == 0 ? (
            <div
              style={{
                marginTop: "200px",
                height: "100px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Fab
                  size="large"
                  style={{
                    border: "3px solid #aaa",
                    boxShadow: "none",
                    backgroundColor: "transparent",
                  }}
                  aria-label="add"
                >
                  <PriorityHighIcon
                    style={{
                      color: "grey",
                    }}
                  />
                </Fab>
                <br />
                <h4 style={{ color: "grey" }}>No teacher leave requests.</h4>
              </div>
            </div>
          ) : (
            ""
          )}
          {teacherLeaveRequests.map((leave, index) => (
            <Grid item md={3}>
              <Box
                style={{
                  minHeight: "100%",
                  borderRadius: "6px",
                  border: "1.3px solid " + themeStyle.primaryColorLight,
                  backgroundColor: "white",
                  boxShadow: "none",
                  padding: "15px",
                }}
              >
                <div
                  style={{
                    margin: "-5px 0px 0px 0px",
                    fontSize: "18px",
                    color: themeStyle.secondaryColor,
                  }}
                >
                  {leave["name"]}
                </div>
                <div style={{ fontSize: "14px" }}>{leave["subject"]}</div>
                <div
                  style={{
                    marginTop: "10px",
                    color: themeStyle.primaryColor,
                  }}
                >
                  {leave["class"]}
                </div>
                <div style={{ marginTop: "-5px" }}>
                  {" "}
                  {moment(leave["date"], "DD-MM-YYYY").format("Do MMMM, YYYY")}
                </div>

                <div style={{ margin: "0px 0px 0px 0px" }}>
                  {leave["description"]}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "-5px",
                    marginRight: "-5px",
                  }}
                >
                  {leave["documents"].length != 0 ? (
                    <Fab
                      size="small"
                      style={{
                        transform: "scale(0.8)",
                        boxShadow: "none",
                        backgroundColor: themeStyle.primaryColor,
                      }}
                      onClick={() => {
                        window.open(leave["documents"], "_blank");
                      }}
                      aria-label="add"
                    >
                      <FileOpenIcon
                        style={{
                          color: "white",
                        }}
                      />
                    </Fab>
                  ) : (
                    ""
                  )}
                  <Fab
                    size="small"
                    style={{
                      transform: "scale(0.8)",
                      boxShadow: "none",
                      backgroundColor:
                        leave["status"] == "PENDING"
                          ? themeStyle.primaryColor
                          : leave["status"] == "APPROVED"
                          ? colorList2[0]
                          : colorList2[2],
                    }}
                    onClick={() => {
                      setLeaveId(leave["id"]);
                      setUserId(leave["user_id"]);
                      setLeaveDate(leave["date"]);
                      setOpen(true);
                    }}
                    aria-label="add"
                  >
                    {leave["status"] == "PENDING" ? (
                      <PriorityHighIcon
                        style={{
                          fontSize: "30px",
                          color: "white",
                        }}
                      />
                    ) : leave["status"] == "APPROVED" ? (
                      <CheckIcon
                        style={{
                          fontSize: "30px",
                          color: "white",
                        }}
                      />
                    ) : (
                      <CloseIcon
                        style={{
                          fontSize: "30px",
                          color: "white",
                        }}
                      />
                    )}
                  </Fab>
                </div>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Fragment>
    );
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_principal) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  borderRadius: "15px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "white",
                  marginTop: "46vh",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent="flex-end">
                    {/* <Grid item md={4}>
                      <Select
                        value={year}
                        // onChange={(e) => handleApprovalChange(e.target.value)}
                        style={{
                          marginTop: "2px",
                          height: "40px",
                          marginBottom: "5px",
                        }}
                        fullWidth
                        variant={"outlined"}
                      >
                        <MenuItem value={"2025"}>2025</MenuItem>
                      </Select>
                    </Grid>{" "} */}
                    {/*   <Grid item md={4}>
                      <Select
                        value={users}
                        onChange={(e) => handleUsersChange(e.target.value)}
                        style={{
                          marginTop: "2px",
                          height: "40px",
                          marginBottom: "5px",
                        }}
                        fullWidth
                        variant={"outlined"}
                      >
                        <MenuItem value={"TEACHERS"}>TEACHERS</MenuItem>
                        <MenuItem value={"ONBOARDING"}>ONBOARDING</MenuItem>
                        <MenuItem value={"STAFF"}>STAFF</MenuItem>
                        <MenuItem value={"DRIVERS"}>DRIVERS</MenuItem>
                      </Select>
                    </Grid> */}
                    <Grid item md={4}>
                      <Select
                        value={type}
                        onChange={(e) => handleApprovalChange(e.target.value)}
                        style={{
                          marginTop: "2px",
                          height: "40px",
                          marginBottom: "5px",
                        }}
                        fullWidth
                        variant={"outlined"}
                      >
                        <MenuItem value={"ALL"}>ALL</MenuItem>
                        <MenuItem value={"PENDING"}>PENDING</MenuItem>
                        <MenuItem value={"APPROVED"}>APPROVED</MenuItem>
                        <MenuItem value={"REJECTED"}>REJECTED</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                }
              />
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      borderRadius: "15px",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <h3>Approve this leave request?</h3>
                      <span>This action cannot be reversed.</span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => approveLeave(true)}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Approve
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => approveLeave(false)}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>

              <div
                style={{
                  borderRadius: "15px",
                  margin: "75px 15px 20px 85px",
                  backgroundColor: "white",
                }}
              >
                {getPageContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default LeaveRequestsPrincipal;
